// @ts-nocheck
import * as React from "react";

const BoxReturnLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m11.16 4.27.201.093a6.498 6.498 0 0 0-.36 2.029l-.711-.332a.73.73 0 0 0-.58 0L4.38 8.54 10 11.15l2.129-.99a6.5 6.5 0 0 0 1.456 1.529L11 12.89v6.72L16.69 17a.48.48 0 0 0 .31-.46v-3.56a6.502 6.502 0 0 0 2-.156v3.716a2.49 2.49 0 0 1-1.47 2.24l-6.4 3a2.7 2.7 0 0 1-2.27 0l-6.4-3A2.49 2.49 0 0 1 1 16.52V9.46a2.39 2.39 0 0 1 .37-1.26l.069-.105L1.52 8l.12-.05a2.6 2.6 0 0 1 .86-.68l6.4-3a2.7 2.7 0 0 1 2.26 0ZM3 10.1v6.47a.47.47 0 0 0 .3.43L9 19.61v-6.72L3 10.1Zm12.573-6.57c.232.072.412.26.48.498a.757.757 0 0 1-.148.691l-.486.513h4.2c.896 0 1.727.464 2.222 1.227l.101.168c.477.86.477 1.919 0 2.779A2.664 2.664 0 0 1 19.62 10.8h-2.53a.709.709 0 0 1-.619-.37.756.756 0 0 1 0-.73.709.709 0 0 1 .618-.37h2.53c.448 0 .862-.25 1.087-.655.226-.407.226-.91 0-1.317a1.247 1.247 0 0 0-1.086-.655h-4.198l.556.58a.75.75 0 0 1-.042.988.697.697 0 0 1-1.041-.033L13.21 6.481a.747.747 0 0 1-.209-.52c0-.195.075-.382.208-.52l1.695-1.763a.696.696 0 0 1 .67-.148Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BoxReturnLine);
